module.exports = __webpack_public_path__ + "static/media/c225e04d.jpg";